/**
 * Yields control back to the main thread so the browser can process
 * other events (SignalR keepalive, rendering, user input) between
 * chunks of heavy computation.
 */
export function yieldToMain(): Promise<void> {
    if ('scheduler' in globalThis && typeof (globalThis as Record<string, unknown>).scheduler === 'object') {
        const scheduler = (globalThis as Record<string, unknown>).scheduler as Record<string, unknown>;
        if (typeof scheduler.yield === 'function') {
            return (scheduler.yield as () => Promise<void>)();
        }
    }
    return new Promise((resolve) => setTimeout(resolve, 0));
}
